var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"dcw-your-future-team"},[_c('DcwNewHeadline',_vm._b({},'DcwNewHeadline',_vm.headlineProps,false)),_vm._v(" "),_c('DcwScrollSnap',{staticClass:"dcw-your-future-team__list",attrs:{"is-list":false,"items":_vm.data.members},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('DcwPersonCard',{attrs:{"person":item}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }